import { render } from "./UserSubscriptions.vue?vue&type=template&id=424cd2cf&scoped=true"
import script from "./UserSubscriptions.vue?vue&type=script&lang=js"
export * from "./UserSubscriptions.vue?vue&type=script&lang=js"

import "./UserSubscriptions.vue?vue&type=style&index=0&id=424cd2cf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424cd2cf"]])

export default __exports__